import gql from "graphql-tag";

export default gql`
  mutation changeDeploymentPrivacy($deploymentId: ID, $privacy: Boolean) {
    changeDeploymentPrivacy(deploymentId: $deploymentId, privacy: $privacy) {
      id
      secondCoachUrl
      contractsConfigUrls {
        id
        name
        url
      }
      codename
      proxyPtz {
        protocol
        hostname
        port
      }
      description
      connectivityFixedIp
      mobileBox
      usuallyDisconnected
      privacyActivated
      contacts {
        name
        description
        email
        telephone
      }
      place {
        name
        telephone
        address
        serverNtp
        timeZone
        daylightSaving
        geo {
          latitude
          longitude
        }
      }
    }
  }
`;
